import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../api';

export default function MyProfile() {
  const [profile, setProfile] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [ecForm, setEcForm] = useState(null);
  const [ecSaving, setEcSaving] = useState(false);
  const [deleting, setDeleting] = useState(null);
  const [tab, setTab] = useState('info');
  const [editContact, setEditContact] = useState(null);

  const load = () => {
    api('/hcm/my-profile').then(r => r.ok ? r.json() : null).then(setProfile);
    api('/hcm/my-emergency-contacts').then(r => r.ok ? r.json() : []).then(setContacts);
  };
  useEffect(load, []);

  if (!profile) return <Layout><div className="text-center py-12 text-gray-500">No employee record linked to your account.</div></Layout>;

  const fullName = [profile.title, profile.firstName, profile.displayMiddleName ? profile.middleName : null, profile.lastName, profile.suffix].filter(Boolean).join(' ');

  return (
    <Layout>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">My Profile</h2>

      <div className="bg-white rounded-lg shadow mb-6">
        <div className="p-6">
          <h3 className="text-xl font-semibold text-gray-900 mb-4">{fullName}</h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div><p className="text-sm text-gray-500">Employee ID</p><p className="font-medium">{profile.employeeId || '—'}</p></div>
            <div><p className="text-sm text-gray-500">Job Title</p><p className="font-medium">{profile.jobTitle || '—'}</p></div>
            <div><p className="text-sm text-gray-500">Department</p><p className="font-medium">{profile.department || '—'}</p></div>
            <div><p className="text-sm text-gray-500">Manager</p><p className="font-medium">{profile.managerName || '—'}</p></div>
            <div><p className="text-sm text-gray-500">Hire Date</p><p className="font-medium">{profile.hireDate || '—'}</p></div>
            <div><p className="text-sm text-gray-500">Employment Type</p><p className="font-medium">{profile.employmentType || '—'}</p></div>
            {profile.workEmail && <div><p className="text-sm text-gray-500">Work Email</p><p className="font-medium">{profile.workEmail}</p></div>}
            {profile.workPhone && <div><p className="text-sm text-gray-500">Work Phone</p><p className="font-medium">{profile.workPhone}</p></div>}
            {profile.personalEmail && <div><p className="text-sm text-gray-500">Personal Email</p><p className="font-medium">{profile.personalEmail}</p></div>}
            {profile.personalPhone && <div><p className="text-sm text-gray-500">Personal Phone</p><p className="font-medium">{profile.personalPhone}</p></div>}
          </div>
          {!editContact ? (
            <button onClick={() => setEditContact({personalEmail: profile.personalEmail || '', personalPhone: profile.personalPhone || ''})} className="mt-4 text-sm text-indigo-600 hover:text-indigo-800 font-medium">Edit Contact Info</button>
          ) : (
            <form onSubmit={async (e) => { e.preventDefault(); await api('/hcm/my-profile/update', {method: 'PUT', body: JSON.stringify(editContact)}); setEditContact(null); load(); }} className="mt-4 flex flex-wrap gap-3 items-end">
              <div><label className="block text-xs font-medium text-gray-700 mb-1">Personal Email</label><input type="email" value={editContact.personalEmail} onChange={e => setEditContact({...editContact, personalEmail: e.target.value})} className="px-3 py-2 border border-gray-300 rounded-lg text-sm" /></div>
              <div><label className="block text-xs font-medium text-gray-700 mb-1">Personal Phone</label><input value={editContact.personalPhone} onChange={e => setEditContact({...editContact, personalPhone: e.target.value})} className="px-3 py-2 border border-gray-300 rounded-lg text-sm" /></div>
              <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 text-sm">Save</button>
              <button type="button" onClick={() => setEditContact(null)} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 text-sm">Cancel</button>
            </form>
          )}
        </div>
      </div>

      <div className="border-b border-gray-200 mb-4">
        <nav className="flex gap-6 px-1">
          {[['info','Addresses'],['emergency','Emergency Contacts']].map(([key, label]) => (
            <button key={key} onClick={() => setTab(key)}
              className={`py-3 text-sm font-medium border-b-2 ${tab === key ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>{label}</button>
          ))}
        </nav>
      </div>

      {tab === 'info' && profile.addresses && profile.addresses.length > 0 && (
        <div className="bg-white rounded-lg shadow p-6 space-y-3">
          {profile.addresses.map(a => (
            <div key={a.id} className="p-3 border rounded-lg">
              {a.line1 && <p className="text-gray-900">{a.line1}</p>}
              {a.line2 && <p className="text-gray-900">{a.line2}</p>}
              <p className="text-gray-900">{[a.city, a.state].filter(Boolean).join(', ')}{a.zip ? ` ${a.zip}` : ''}</p>
            </div>
          ))}
        </div>
      )}

      {tab === 'emergency' && (
        <div className="bg-white rounded-lg shadow">
          <div className="p-4 border-b flex justify-end">
            <button onClick={() => setEcForm({name: '', relationship: '', phone: '', email: ''})} className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 text-sm">Add Contact</button>
          </div>
          {contacts.length === 0 ? (
            <div className="text-center py-8 text-gray-500">No emergency contacts on file.</div>
          ) : (
            <div className="divide-y">
              {contacts.map(ec => (
                <div key={ec.id} className="px-4 py-4 flex items-start justify-between">
                  <div>
                    <div className="flex items-center gap-3">
                      <span className="font-medium text-gray-900">{ec.name}</span>
                      {ec.relationship && <span className="text-xs bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded">{ec.relationship}</span>}
                    </div>
                    <div className="flex gap-4 mt-1 text-sm text-gray-500">
                      {ec.phone && <span>{ec.phone}</span>}
                      {ec.email && <span>{ec.email}</span>}
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <button onClick={() => setEcForm({id: ec.id, name: ec.name, relationship: ec.relationship || '', phone: ec.phone || '', email: ec.email || ''})} className="text-sm text-gray-500 hover:text-indigo-600">Edit</button>
                    <button onClick={() => setDeleting(ec)} className="text-sm text-gray-500 hover:text-red-600">Delete</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {ecForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={() => setEcForm(null)}>
          <form onSubmit={async e => {
            e.preventDefault(); setEcSaving(true);
            const body = {name: ecForm.name, relationship: ecForm.relationship || null, phone: ecForm.phone || null, email: ecForm.email || null};
            const res = ecForm.id
              ? await api(`/hcm/my-emergency-contacts/${ecForm.id}`, {method: 'PUT', body: JSON.stringify(body)})
              : await api('/hcm/my-emergency-contacts', {method: 'POST', body: JSON.stringify(body)});
            if (res.ok) { setEcForm(null); load(); }
            setEcSaving(false);
          }} onClick={e => e.stopPropagation()} className="bg-white rounded-lg shadow-xl p-6 w-full max-w-lg space-y-4">
            <h3 className="text-lg font-semibold text-gray-900">{ecForm.id ? 'Edit' : 'Add'} Emergency Contact</h3>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
              <input required value={ecForm.name} onChange={e => setEcForm({...ecForm, name: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none" />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Relationship</label>
                <select value={ecForm.relationship} onChange={e => setEcForm({...ecForm, relationship: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg">
                  <option value="">Select...</option>
                  {['Spouse','Parent','Sibling','Child','Friend','Other'].map(r => <option key={r} value={r}>{r}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                <input value={ecForm.phone} onChange={e => setEcForm({...ecForm, phone: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input type="email" value={ecForm.email} onChange={e => setEcForm({...ecForm, email: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg" />
            </div>
            <div className="flex justify-end gap-3">
              <button type="button" onClick={() => setEcForm(null)} className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg">Cancel</button>
              <button type="submit" disabled={ecSaving} className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50">{ecSaving ? 'Saving...' : 'Save'}</button>
            </div>
          </form>
        </div>
      )}

      {deleting && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={() => setDeleting(null)}>
          <div onClick={e => e.stopPropagation()} className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
            <h3 className="text-lg font-bold text-gray-900 mb-2">Delete Emergency Contact</h3>
            <p className="text-gray-600 mb-6">Are you sure you want to delete "{deleting.name}"?</p>
            <div className="flex justify-end gap-3">
              <button onClick={() => setDeleting(null)} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Cancel</button>
              <button onClick={async () => { await api(`/hcm/my-emergency-contacts/${deleting.id}`, {method: 'DELETE'}); setDeleting(null); load(); }} className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">Delete</button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
